// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-B":"Thumb_vanlife-roadtrips-B__NaGFM"};